import { css } from 'styled-components';
import { rem } from 'polished';

const circulo = color => css`
  background-color: ${color};
  border-radius: 50%;
  height: ${rem('12px')};
  width: ${rem('12px')};
`;

/**
 * Create inside of a pseudo element
 * a block
 * @param {widthRem}
 */
const pseudoBlock = (widthRem = 2.5) => css`
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  width: ${widthRem}rem;
  z-index: 1;
`;

// Ellipsis multiline
// Params: maxheight (px)
// lineHeight
const ellipsisMultiline = (maxHeight, lineHeight) => css`
  display: block;
  overflow: hidden;
  position: relative;
  line-height: ${lineHeight};
  max-height: ${rem(maxHeight)};
  text-align: justify;

  /* */
  margin-right: -1em;
  padding-right: 1em;

  &:before {
    content: '...';
    position: absolute;
    right: 0;
    bottom: ${rem('2px')};
  }
  &:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1em;
    height: 1em;
    margin-top: 0.2em;
    background: ${props => props.theme.colors.grayLightest};
  }
`;

export { circulo, pseudoBlock, ellipsisMultiline };

// EJEMPLO DE USO:
// En el Style.js
// import { circulo } from '../../../utils/mixins';
// const StyledStateNotifications = styled.p`
//  &:before {
//    ${props => circulo(props.theme.colors[props.typeState])};
